import i18n from '..//..//VueI18n'

export const tiposDeOrdensDeServico = {
	INVENTARIO_DE_INSTALACAO: '001',
	INVENTARIO_CONTINUO: '002',
	INVENTARIO_PRE_CORTE: '003',
	INVENTARIO_DE_QUALIDADE: '019',
	INSTALACAO_DE_DENDROMETROS: '004',
	COLETA_DE_CUBAGEM: '005',
	COLETA_HIGH_PRECISION: '006',
	INSTALACAO_SINGLE_TREES: '007',
	COLETA_SINGLE_TREES: '008',
	INVENTARIO_DE_PILHA: '018',
}

export const tipoDeOrdemDeServicoComDescricao = [
	{
		descricao: i18n.t('instalationInventory'),
		codigo: '001',
		abreviacao: 'IFI',
		opcoesDeOSDisponiveisCronograma: [{ label: i18n.t('instalationInventory'), value: '001' }],
	},
	{
		descricao: i18n.t('continueInventory'),
		codigo: '002',
		abreviacao: 'IFC',
		opcoesDeOSDisponiveisCronograma: [{ label: i18n.t('continueInventory'), value: '002' }],
	},
	{
		descricao: i18n.t('inventarioPreCorte'),
		codigo: '003',
		abreviacao: 'IPC',
		opcoesDeOSDisponiveisCronograma: [{ label: i18n.t('inventarioPreCorte'), value: '003' }],
	},
	{ descricao: i18n.t('inventarioDeQualidade'), codigo: '019', abreviacao: 'IFQ' },
	{ descricao: i18n.t('coletaDeCubagem'), codigo: '005', abreviacao: 'Cubagem' },
	{
		descricao: i18n.t('instalacaoSingleTrees'),
		codigo: '007',
		abreviacao: 'Instalação Single Trees',
	},
	{ descricao: i18n.t('coletaSingleTrees'), codigo: '008', abreviacao: 'Coleta Single Trees' },
]
